import { render, staticRenderFns } from "./AppName.vue?vue&type=template&id=320a6f9c&scoped=true"
import script from "./AppName.vue?vue&type=script&lang=js"
export * from "./AppName.vue?vue&type=script&lang=js"
import style0 from "./AppName.vue?vue&type=style&index=0&id=320a6f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a6f9c",
  null
  
)

export default component.exports